import React, { useRef, useEffect, useState, useCallback } from 'react';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet-routing-machine';
import '../map.css';
import axios from 'axios';
import Sheet from 'react-modal-sheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../color';
import { v4 as uuidv4 } from 'uuid';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { DislikeFilled, LikeFilled, LikeOutlined, DislikeOutlined } from '@ant-design/icons';
import { EnvironmentOutlined, EnvironmentFilled, PlusOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { FaCrosshairs, FaExclamationTriangle, FaTrash } from 'react-icons/fa';
import { io } from 'socket.io-client';
import { ServerIP } from '../component/ServerIP';





const DriverHomeMap = ({ }) => {

    const params = new URLSearchParams(window.location.search);
    const driverIdUrl = params.get('driverId');
    const userId = driverIdUrl


    //Map

    const mapContainer = useRef(null);
    const map = useRef(null);
    const center = { lat: 18.6565184, lng: -72.3156992 };
    const [location, setLocation] = useState([18.32, -72.17]);

    const [zoom] = useState(12);


    useEffect(() => {
        if (map.current) return;

        map.current = new L.Map(mapContainer.current, {
            center: L.latLng(center.lat, center.lng),
            zoom: zoom,
            zoomControl: false,
        });


        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 20,
            minZoom: 3,
        }).addTo(map.current);

        fetchNearbyMarker();

    }, [center.lat, center.lng, zoom]);






    //Alert

    const userMarkerRef = useRef(null);
    const [alertMarker, setAlertMarker] = useState([]);

    function getColor(title) {
        switch (title) {
            case 'Tir':
                return 'rgba(255,0,0,0.5)';
            case 'Kidnapping':
                return 'rgba(230, 126, 34, 0.5)';
            case 'Blocked':
                return 'gray';
            default:
                return 'black';
        }
    }

    function getIcon(title) {
        switch (title) {
            case 'Tir':
                return L.icon({ iconUrl: require('../data/IconImageMap/gun.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Kidnapping':
                return L.icon({ iconUrl: require('../data/IconImageMap/child.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Blocked':
                return L.icon({ iconUrl: require('../data/IconImageMap/block1.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            default:
                return L.icon({ iconUrl: require('../data/IconImageMap/block.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
        }
    }

    function getRadius(title) {
        switch (title) {
            case 'Tir':
                return 400;
            case 'Kidnapping':
                return 600;
            case 'Blocked':
                return 100;
            default:
                return 100;
        }
    }

    const markersRef = useRef([]);
    const circlesRef = useRef([]);

    useEffect(() => {
        if (Array.isArray(alertMarker) && alertMarker.length > 0) {
            // Supprimez les anciens marqueurs et cercles
            markersRef.current.forEach(marker => marker.remove());
            circlesRef.current.forEach(circle => circle.remove());

            // Réinitialisez les tableaux
            markersRef.current = [];
            circlesRef.current = [];

            alertMarker.map((marker, index) => {
                if (marker.coordinate) {
                    const icon = getIcon(marker.title);
                    const markerInstance = L.marker([marker.coordinate.latitude, marker.coordinate.longitude], { icon }).addTo(map.current);
                    markerInstance.bindPopup(`${marker.title} - ${getTime(marker.createdAt)}`);

                    markerInstance.on('click', () => {
                        map.current.flyTo([marker.coordinate.latitude, marker.coordinate.longitude] , map.current.getZoom());
                    });

                    const circle = L.circle([marker.coordinate.latitude, marker.coordinate.longitude], { radius: getRadius(marker.title), fillColor: getColor(marker.title), fillOpacity: 0.2, color: getColor(marker.title) }).addTo(map.current);

                    // Ajoutez les instances de marqueurs et de cercles aux tableaux
                    markersRef.current.push(markerInstance);
                    circlesRef.current.push(circle);
                }
            });
        }
    }, [alertMarker]);


    const fetchNearbyMarker = async () => {

        await axios.get(`${ServerIP}/alert/getAlert`)
            .then(res => {
                // console.log(res.data.alertMarker)
                setAlertMarker(res.data.alertMarker)
            })
    };


    const getTime = (time) => {
        var date = new Date(time);
        var maintenant = new Date();
        var difference = Math.abs(maintenant - date); // en millisecondes

        var minutes = Math.floor(difference / 60000);
        if (minutes < 60) {
            return minutes + " min";
        } else {
            var heures = Math.floor(minutes / 60);
            return heures + " h";
        }

    };



    ///Coordinate and missions
    
    const intervalIdRef = useRef(null);

    const socketRef = useRef(null);  // Utiliser useRef pour stocker la socket

    useEffect(() => {
        // Créer une seule connexion socket.io
        if (!socketRef.current) {
            socketRef.current = io(process.env.REACT_APP_SERVER_IP, {
                withCredentials: true,
                transports: ["websocket", "polling"],
            });
        }

        socketRef.current.connect();

        // Écouter les événements de connexion et de déconnexion
        socketRef.current.on('connect', () => {
            console.log('Socket connected:', socketRef.current.id);
        });

        socketRef.current.on('disconnect', () => {
            console.log('Socket disconnected');
        });

        // Appeler la fonction pour récupérer les coordonnées
        getCoordinate();

        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current); // Nettoyer l'intervalle au démontage
            }

            // Déconnecter le socket au démontage du composant
            if (socketRef.current) {
                socketRef.current.disconnect();
            }
        };
    }, []); 


    const getCoordinate = async () => {
        try {
            const res = await axios.get(`${ServerIP}/mission/getCoordinateMission/${driverIdUrl}`);
            if (res.status === 200) {
                intervalIdRef.current = setInterval(updateLocation, 5000);
            } else {
                intervalIdRef.current = setInterval(getRealTimePosition, 5000);
            }
        } catch (err) {
            console.log(err);
        }
    };


    const updateLocation = async () => {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, { maximumAge: 5000 });
            });

            const { latitude, longitude } = position.coords;

            setLocation([latitude, longitude]);

            const userIcon = L.icon({
                iconUrl: require('../data/IconImageMap/currentLocation.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 35],
            });

            // Mettre à jour la position de l'icône de l'utilisateur sur la carte
            if (!userMarkerRef.current) {
                userMarkerRef.current = L.marker([latitude, longitude], { icon: userIcon }).addTo(map.current);
            } else {
                userMarkerRef.current.setLatLng([latitude, longitude]);
            }

            // Si c'est la première fois, déplacer la carte vers la position actuelle de l'utilisateur
            if (firstCallRef.current) {
                map.current.flyTo([latitude, longitude], map.current.getZoom());
                firstCallRef.current = false;
            }

            // Envoyer les données de localisation via le socket
            if (socketRef.current && socketRef.current.connected) {
                console.log('Emitting sendLocation event');
                socketRef.current.emit('sendLocation', {
                    id: driverIdUrl,
                    latitude,
                    longitude,
                    roomId: driverIdUrl,
                });
            } else {
                console.error('Socket is not connected');
            }
        } catch (error) {
            console.error('Erreur de géolocalisation:', error);
        }
    };


    const firstCallRef = useRef(true);
    const [isPressed, setIsPressed] = useState(false);

    const getRealTimePositionFunc = async () => {
        intervalIdRef.current = setInterval(getRealTimePosition, 5000);

        if (!map.current.getCenter().equals([location[0], location[1]]) && firstCallRef.current === false) {
            map.current.flyTo([location[0], location[1]], map.current.getZoom());
        }
    }

    const getRealTimePosition = async () => {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, { maximumAge: 5000 });
            });

            const { latitude, longitude } = position.coords;

            setLocation([latitude, longitude]);

            const userIcon = L.icon({
                iconUrl: require('../data/IconImageMap/currentLocation.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 36],
            });

            if (!userMarkerRef.current) {
                userMarkerRef.current = L.marker([latitude, longitude], { icon: userIcon }).addTo(map.current);
            } else {
                userMarkerRef.current.setLatLng([latitude, longitude]);
            }


            if (firstCallRef.current === true) {
                map.current.flyTo([latitude, longitude], map.current.getZoom());
                firstCallRef.current = false;
            }


        } catch (error) {
            console.error('Erreur de géolocalisation:', error);
        }
    };



    return (


        <div className="map-wrap">


            <div style={{ position: 'absolute', width: '100%', height: '100%' }}>


                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        right: '3%',
                        top: '66%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                        borderWidth: '1px',
                        backgroundColor: isPressed ? colors.white : colors.accent,
                        height: 50,
                        width: 50,
                        borderRadius: '50%',
                        display: 'flex',
                        alignSelf: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'transform 0.1s, background-color 0.1s',
                        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
                    }}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                    onTouchStart={() => setIsPressed(true)}
                    onTouchEnd={() => setIsPressed(false)}
                    onTouchCancel={() => setIsPressed(false)}
                    onClick={getRealTimePositionFunc}
                >
                    <FaCrosshairs size={20} color={colors.black} />
                </div>

                <div
                    style={{
                        position: 'absolute',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        bottom: 0,
                        top: 0,
                        right: 0,
                        left: 0,
                        zIndex: 1,
                        height: 50,
                        width: 50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <PlusOutlined style={{ color: colors.black, marginLeft: '5px', fontSize: '12px' }} />
                </div>


            </div>

            <div ref={mapContainer} className="map" style={{ zIndex: 0 }} />

        </div >

    )
}

export default DriverHomeMap;


